import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmDataService } from '../../../pages/sm/services/sm-data.service';
import { EventService } from '../../../core/services/event.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent {
  @Input() body: any
  @Input() header: any

  indexedDBVersion = 26;
  offlinePostFailList: any;
  constructor(private ngbActiveModal: NgbActiveModal, private smDataService: SmDataService, private eventService: EventService) { }

  ngOnInit() {
    let indexdb = window.indexedDB.open("KDS_SM_DB", this.indexedDBVersion);
    indexdb.onsuccess = () => {
      let db = indexdb.result;
      let transaction = db.transaction("SM_OfflineSyncFail", "readwrite");
      let storage = transaction.objectStore("SM_OfflineSyncFail");
      let offlinePostFailList = storage.getAll();
      offlinePostFailList.onsuccess = () => {
        this.offlinePostFailList = offlinePostFailList.result;
      }
    }
  }

  public cancelClicked() {
    this.ngbActiveModal.close()
  }

  public confirmClicked() {
    this.ngbActiveModal.close(true);
  }

  public deleteClicked() {
    let indexdb = window.indexedDB.open("KDS_SM_DB", this.indexedDBVersion);
    indexdb.onsuccess = () => {
      let db = indexdb.result;
      let transaction = db.transaction("SM_OfflineSyncFail", "readwrite");
      let storage = transaction.objectStore("SM_OfflineSyncFail");
      storage.clear();
      this.smDataService.haveOfflinePostFail = false;
      this.eventService.broadcast('haveOfflinePostFail', this.smDataService.haveOfflinePostFail);
    }

    let indexdb2 = window.indexedDB.open("KDS_SM_DB", this.indexedDBVersion);
    indexdb2.onsuccess = () => {
      let db = indexdb2.result;
      let transaction = db.transaction("SM_PostCalls", "readwrite");
      let storage = transaction.objectStore("SM_PostCalls");
      $.each(this.offlinePostFailList, function (key, val) {
        storage.delete(val.deleteID);
      });
    }
    this.ngbActiveModal.close(false);
  }
}
